// @ts-nocheck
import { YStack, styled } from 'tamagui';

export const Container = styled(YStack, {
  width: '100%',
  maxWidth: 1200,
  marginHorizontal: 'auto',
  paddingHorizontal: '$4',
});
